import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import TrialBalanceTable from './TrialBalanceTable';

function TrialBalance() {


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Trial Balance" 
        breadcrumb={["Dashboard", "Accounts", "Trial Balance"]} 
      />

      <HStack align="start" w='100%' gap="0" mt={2}  p={{base:"2",md:"6"}}>
        <TrialBalanceTable  />

      </HStack>
    </div>
  );
}

export default TrialBalance;
